import filter from "lodash/filter";
import { createSelector } from "reselect";
import sortBy from "lodash/sortBy";

export const individualsSelector = (state) => state.individuals.items;
export const currentIndividualIdSelector = (state) => state.individuals.currentIndividualId;

export const getCurrentIndividual = createSelector(
  individualsSelector,
  currentIndividualIdSelector,
  (individuals, currentIndividualId) => currentIndividualId &&
    individuals[currentIndividualId] &&
    individuals[currentIndividualId].attributes
);

export const getViewingAs = (state) => state.individuals.viewing_as;

export const getViewingAsOtherId = createSelector(
  [getViewingAs],
  (viewingAs) => viewingAs && (viewingAs.key === "me" ? null : viewingAs.key)
);

export const makeGetViewingIndividualId = () => createSelector(
  [getCurrentIndividual, getViewingAsOtherId],
  (currentIndividual, viewingAsOtherId) => viewingAsOtherId || currentIndividual.id
);

export const makeGetViewingIndividual = () => createSelector(
  [individualsSelector, makeGetViewingIndividualId()],
  (individuals, viewingIndividualId) => individuals[viewingIndividualId]
);

export const getCommunityIndividuals = createSelector(
  [individualsSelector],
  (individuals) => {
    const communityIndividuals = filter(individuals, ({ attributes }) => attributes.isCommunity && !attributes.isBlocked);
    return sortBy(communityIndividuals, ({ attributes }) => attributes.lastName);
  }
);

export const getBlockedCommunityIndividuals = createSelector(
  [individualsSelector],
  (individuals) => {
    const blockedIndividuals = filter(individuals, ({ attributes }) => attributes.isBlocked);
    return sortBy(blockedIndividuals, ({ attributes }) => attributes.lastName);
  }
);

export const getCareerPageApprovedIndividuals = createSelector(
  [individualsSelector],
  (individuals) => {
    const careerPageApprovedIndividuals = filter(individuals, ({ attributes }) => attributes.isCareerPageApproved);
    return sortBy(careerPageApprovedIndividuals, ({ attributes }) => attributes.applicationApprovedAt).reverse();
  }
);
